// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2664":"93b819c5","6391":"97430582","13303":"97430582","36884":"069f7d80","47967":"97430582","77477":"97430582","87397":"97430582","90648":"97430582"}[chunkId] + ".chunk.css";
};